import { QUIZ_ERROR } from 'constants';

const extractAction = (rules, condition) => {
  const rule = rules.find((r) => r.condition === condition);
  return rule || null;
};

const extractTriggers = (triggers) => {
  return triggers.map((trigger) => {
    const choiceConditions = trigger?.choiceConditions?.map((condition) => ({
      status: condition?.status,
      choiceId: condition?.choiceId,
    }));
    const tagConditions = trigger?.tagConditions?.map((condition) => ({
      status: condition?.status,
      tagId: condition?.tagId,
    }));
    return {
      ...(choiceConditions && { choiceConditions }),
      ...(tagConditions && { tagConditions }),
      action: {
        rule: trigger?.action?.rule,
        nextActivityItemId: trigger?.action?.nextActivityItemId,
      },
      feedback: {
        display: trigger?.feedback?.display,
        message: trigger?.feedback?.message,
      },
      ignoreNextTriggers: trigger?.ignoreNextTriggers,
    };
  });
};

const checkIfActionIDExist = (correctAction, incorrectAction, items) => {
  const correctItemExist =
    correctAction !== null && correctAction?.action === 'GoToItem'
      ? items.find((el) => {
          if (el.item.id === correctAction?.actionValue) return true;
        })
      : true;

  const incorrectItemExist =
    incorrectAction !== null && incorrectAction?.action === 'GoToItem'
      ? items.find((el) => {
          if (el.item.id === incorrectAction?.actionValue) return true;
        })
      : true;

  return correctItemExist && incorrectItemExist;
};

export const generateNavigationMap = (items) => {
  const navigationRules = {};
  let error = false;

  for (const question of items) {
    const itemId = question?.item?.id;
    const correctAction = extractAction(question.item?.rules, 'IsCorrect');
    const incorrectAction = extractAction(question.item?.rules, 'IsIncorrect');

    if (!checkIfActionIDExist(correctAction, incorrectAction, items)) {
      error = true;
      break;
    }
    const triggers = question.item?.triggers
      ? extractTriggers(question.item?.triggers)
      : [];

    navigationRules[itemId] = {
      ...(correctAction && { correctAction }),
      ...(incorrectAction && { incorrectAction }),
      ...(triggers.length > 0 && { triggers }),
    };
  }

  return error ? QUIZ_ERROR.ITEM_NOT_FOUND : navigationRules;
};
